import { render, staticRenderFns } from "./WidgetCategoryReviewsBestGalleryPc.vue?vue&type=template&id=6462df98"
import script from "./WidgetCategoryReviewsBestGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsBestGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports